import { useState, useEffect } from 'react';

import { UserItem } from 'src/@types/users/user-item';
import { UsersFilter } from 'src/@types/users/usersFilter';
import aspUserService from 'src/services/asp-identity/aspUserService';

let cachedUsers: UserItem[] | null = null;
let inflight: Promise<UserItem[]> | null = null;

function loadDirectory(): Promise<UserItem[]> {
  if (cachedUsers) {
    return Promise.resolve(cachedUsers);
  }
  if (inflight) {
    return inflight;
  }

  const filter = new UsersFilter();
  filter.searchQuery = null;
  filter.offset = 0;
  filter.limit = 10000;

  const pending = aspUserService
    .getUserItems(filter)
    .then((result) => {
      const activeUsers = (result.items ?? []).filter((user: UserItem) => !user.isDeactivated);
      cachedUsers = activeUsers;

      return activeUsers;
    })
    .catch((error) => {
      inflight = null;
      throw error;
    });

  inflight = pending;

  return pending;
}

export default function useDirectoryEmails() {
  const [emails, setEmails] = useState<string[]>([]);

  useEffect(() => {
    let isCurrent = true;

    loadDirectory()
      .then((users) => {
        if (isCurrent) {
          setEmails(users.map((user) => user.email).filter(Boolean));
        }
      })
      .catch(() => setEmails([]));

    return () => {
      isCurrent = false;
    };
  }, []);

  return emails;
}
